export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_nl.b7234dc65f8384a5.json"